"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ForceChangePassword;
var _react = _interopRequireWildcard(require("react"));
var _awsAmplify = require("aws-amplify");
var _reactRouterDom = require("react-router-dom");
var _ForceChangePasswordComponent = _interopRequireDefault(require("../components/ForceChangePasswordComponent"));
var _helper = require("../common_features/utility/helper");
var _reactRedux = require("react-redux");
var _strings = require("../common_features/utility/strings");
var _images = _interopRequireDefault(require("../common_features/assets/images"));
var _Services = require("../common_features/utility/Services");
var _loginReducer = require("../common_features/redux/reducers/loginReducer");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ForceChangePassword(props) {
  const [isLoading, setIsLoading] = (0, _react.useState)(false);
  const [newPassword, setPassword] = (0, _react.useState)(null);
  const [confirmNewPassword, setConfirmPassword] = (0, _react.useState)(null);
  const [chnagePasswordTermsCheckbox, setChnagePasswordTermsCheckbox] = (0, _react.useState)(false);
  const [tipsAndTricksCheckbox, setTipsAndTricksCheckbox] = (0, _react.useState)(false);
  const [hasMinLength, setHasMinLength] = (0, _react.useState)(false);
  const [hasOneUpperLowerCase, sethasOneUpperLowerCase] = (0, _react.useState)(false);
  const [hasOneNumber, setHasOneNumber] = (0, _react.useState)(false);
  const [hasSpecialChar, setHasSpecialChar] = (0, _react.useState)(false);
  const [isConfirmPasswordTouch, setIsConfirmPasswordTouch] = (0, _react.useState)(false);
  const [isNewPasswordTouch, setIsNewPasswordTouch] = (0, _react.useState)(false);
  const navigate = (0, _reactRouterDom.useNavigate)();
  const dispatch = (0, _reactRedux.useDispatch)();
  const {
    userInfo
  } = (0, _reactRedux.useSelector)(state => state.login);
  const {
    email,
    password
  } = userInfo;
  function validatePassword(e, handler) {
    const value = e.target.value;
    setHasMinLength(value.length > 7);
    sethasOneUpperLowerCase(/[a-z]/.test(value) && /[A-Z]/.test(value));
    setHasOneNumber(/\d/.test(value));
    setHasSpecialChar(_strings.VALIDATION_REGX.specialCharacter.test(value));
    (0, _helper.onChangeHandler)(e, handler);
  }
  function checkDisabled() {
    const passwordValid = hasMinLength && hasOneNumber && hasOneUpperLowerCase && hasSpecialChar;
    return passwordValid && newPassword === confirmNewPassword && chnagePasswordTermsCheckbox || false;
  }
  const handleConfirmPasswordChange = (e, state) => {
    setIsConfirmPasswordTouch(true);
    (0, _helper.onChangeHandler)(e, state);
  };
  const handleNewPasswordBlur = () => {
    setIsNewPasswordTouch(true);
  };
  const getCurrentRole = user => {
    (0, _Services.getRoles)().then(res => {
      if (res.success) {
        dispatch((0, _loginReducer.SetUserRoles)(res.data));
      }
    });
    let userType = user.signInUserSession.accessToken.payload["cognito:groups"][0];
    let roleId = (0, _helper.getRoleType)(userType);
    dispatch((0, _loginReducer.loginUserInfo)({
      email: email,
      password: password,
      challengeName: user.challengeName,
      poolId: user.pool.userPoolId,
      username: user.username,
      userType: roleId
    }));
  };
  function changePasswordFirstLogin() {
    if (newPassword) {
      setIsLoading(true);
      _awsAmplify.Auth.signIn(email, password).then(user => {
        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          _awsAmplify.Auth.completeNewPassword(user,
          // the Cognito User Object
          newPassword // the new password
          ).then(user => {
            var _user$challengeParam;
            getCurrentRole(user);
            (0, _Services.UpdateSignIn)();
            console.log("user---?", user);
            setIsLoading(false);
            let targetRoute = (0, _helper.checkOnboardingFlag)(user === null || user === void 0 ? void 0 : (_user$challengeParam = user.challengeParam) === null || _user$challengeParam === void 0 ? void 0 : _user$challengeParam.userAttributes["custom:onboarding_flag"]);
            navigate(targetRoute);
          }).catch(e => {
            console.log(e);
            setIsLoading(false);
          });
        }
      }).catch(error => {
        console.log("User Error", error);
        setIsLoading(false);
      });
    }
  }
  (0, _react.useEffect)(() => {
    if (!(email && password)) {
      navigate("/Login");
    }
  });
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_ForceChangePasswordComponent.default, {
    headerImage: _images.default.pentairLogo.default,
    newpassword: newPassword,
    onChangeNewPassword: e => {
      validatePassword(e, setPassword);
    },
    confirmNewPassword: confirmNewPassword,
    onChangeConfirmNewPassword: e => {
      handleConfirmPasswordChange(e, setConfirmPassword);
    },
    chnagePasswordTermsCheckbox: chnagePasswordTermsCheckbox,
    onChangePasswordTermsCheckbox: e => {
      (0, _helper.onChangeHandler)(e, setChnagePasswordTermsCheckbox);
    },
    tipsAndTricksCheckbox: tipsAndTricksCheckbox,
    onChangeTipsAndTricksCheckbox: e => {
      (0, _helper.onChangeHandler)(e, setTipsAndTricksCheckbox);
    },
    onClickContinue: changePasswordFirstLogin,
    isLoading: isLoading,
    hasMinLength: (0, _helper.getPasswordConditionCheckColor)(hasMinLength),
    hasOneNumber: (0, _helper.getPasswordConditionCheckColor)(hasOneNumber),
    hasOneUpperLowerCase: (0, _helper.getPasswordConditionCheckColor)(hasOneUpperLowerCase),
    hasSpecialChar: (0, _helper.getPasswordConditionCheckColor)(hasSpecialChar),
    isContinueDisabled: checkDisabled(),
    isPrivacyTextVisible: true,
    isTipsVisible: true,
    isTermsVisible: true,
    headerText: "Change Password",
    isSubTextVisible: true,
    buttonText: "Change Password",
    subText: "Please create a new password",
    passwordText: "New Password",
    newPasswordPlaceholder: "Enter new password",
    validationText1: "At least 8 characters",
    validationText2: "1 uppercase and 1 lowercase",
    validationText3: "1 number",
    validationText4: "1 special character",
    confirmPassword: "Confirm New Password",
    confirmPasswordPlaceholder: "Confirm new password",
    termserviceText: "I have read and agree to the ",
    termserviceTextUrl: "https://www.pentair.com/en-us/legal/terms-of-use/sc-app-terms-and-conditions-en-us.html",
    termserviceText2: "Terms of Service.",
    tipsText: "I would like to receive Pentair communications regarding helpful tips and tricks, product updates, surveys and special offers. You may withdraw your consent at any time.",
    privacyText: "Your personal information will be handled in accordance with our ",
    privacyText2: "Privacy notice.",
    errorMessage: !(hasMinLength && hasOneNumber && hasOneUpperLowerCase && hasSpecialChar),
    conFirmErrorMessageFP: confirmNewPassword !== newPassword && isConfirmPasswordTouch,
    handleNewPasswordBlur: handleNewPasswordBlur,
    isNewPasswordTouch: isNewPasswordTouch,
    navigationUrl: "https://www.pentair.com/en-us/legal/privacy-notice.html"
  }));
}